import { render, staticRenderFns } from "./AwardBadge.vue?vue&type=template&id=89be4248&"
import script from "./AwardBadge.vue?vue&type=script&lang=js&"
export * from "./AwardBadge.vue?vue&type=script&lang=js&"
import style0 from "./AwardBadge.vue?vue&type=style&index=0&id=89be4248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports